const delay = (ms) => new Promise((r) => setTimeout(r, ms));

export { delay };

export async function apiRequest(path, options = {}) {
  const { API_BASE_URL } = await import("./config.js");
  const res = await fetch(`${API_BASE_URL}${path}`, {
    headers: { "Content-Type": "application/json", ...options.headers },
    ...options,
  });
  if (!res.ok) throw new Error(`API ${res.status}: ${path}`);
  return res.json();
}
